/* Čapkov redesign: jednotné slidery (domů: bestsellery, páry, dárky, kategorie, recenze). Prvky s [data-rd-slider].
   Šablonový scroll-carousel / image-link-blocks posouvá šipkou po JEDNÉ kartě; tady se události control:prev/next zachytí dřív (capture na document)
   a posun se udělá o celou stránku (šířka okna minus kousek na „peek“). Díky delegaci funguje i u sekcí vložených po načtení (capkov-rd-lazy.js).
   Stav šipek (na krajích zmizí) a ukazatel pokroku řeší tento soubor; CSS snap je v capkov-rd.css (mobil proximity, desktop mandatory). */
(function () {
  'use strict';
  if (window.__rdSlider) return; window.__rdSlider = 1;
  var RM = window.matchMedia ? matchMedia('(prefers-reduced-motion:reduce)') : { matches: false };
  function host(t) { return t && t.closest ? t.closest('[data-rd-slider]') : null; }
  function items(el) {
    return [].filter.call(el.querySelectorAll('product-card,.image-link-blocks__item,.rdr__card,.rd-hpair'), function (i) { return i.offsetParent !== null; });
  }
  function metrics(el) {
    var it = items(el), cs = getComputedStyle(el);
    var step = it.length > 1 ? it[1].offsetLeft - it[0].offsetLeft : (it[0] ? it[0].offsetWidth : el.clientWidth);
    var avail = el.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    return { step: step, avail: avail, n: it.length };
  }
  function go(el, dir) {
    var m = metrics(el), peek = Math.min(48, m.step * 0.2);
    var amount = Math.max(m.step, m.avail - peek);
    var max = el.scrollWidth - el.clientWidth;
    var target = Math.max(0, Math.min(max, el.scrollLeft + dir * amount));
    el.scrollTo({ left: target, behavior: RM.matches ? 'auto' : 'smooth' });
  }
  /* přebije jednokartový posun šablony: capture na document běží před posluchači na samotném prvku */
  ['control:next', 'control:prev'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      var el = host(e.target); if (!el) return;
      e.stopImmediatePropagation(); e.stopPropagation();
      go(el, name === 'control:next' ? 1 : -1);
    }, true);
  });
  /* ovládací prvky jednou (cache): za pohybu se nehledá v DOM; píše se jen při změně stavu */
  function ctl(el) { return el.__rdCtl || (el.__rdCtl = [].slice.call(document.querySelectorAll('[aria-controls="' + el.id + '"]')).filter(function (c) { return c.tagName === 'BUTTON'; })); }
  function upd(el) {
    var max = el.scrollWidth - el.clientWidth - 2, x = Math.abs(el.scrollLeft), over = max > 0;
    if (!el.id) return;
    ctl(el).forEach(function (c) {
      var prev = c.getAttribute('is') === 'prev-button', d = prev ? x <= 2 : x >= max;
      if (c.disabled !== d) c.disabled = d;
    });
    el.classList.toggle('is-scrollable', over); /* šablonové .peer-not-scrollable:hidden skryje ukazatel, když není co posouvat */
  }
  /* Ukazatel pokroku (scroll-progress): šablona na každý snímek posunu přepisuje --scroll-progress (restyle + nová vrstva).
     Kde to prohlížeč umí, jede pruh po scroll-timeline posuvníku na compositoru (JS nic nedělá); poměr viditelné/celé šířky drží ResizeObserver. */
  var TL = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline', 'scroll()') && CSS.supports('timeline-scope', '--a')), tlN = 0;
  if (TL) {
    var st = document.createElement('style');
    st.textContent = '@keyframes rdsp{from{transform:scaleX(var(--rd-sp0,.3))}to{transform:scaleX(1)}}.scrollbar__progress[data-rd-tl]::before{transform:scaleX(1);animation:rdsp linear both;animation-timeline:var(--rd-tl)}';
    document.head.appendChild(st);
  }
  function tl(el) {
    if (!TL || el.__rdTl || !el.id) return; var pr = document.querySelector('scroll-progress[observes="' + el.id + '"]'); if (!pr) return;
    var scope = pr.parentElement; while (scope && !scope.contains(el)) scope = scope.parentElement; if (!scope) return;
    el.__rdTl = 1; var name = '--rdsp' + (++tlN);
    el.style.scrollTimelineName = name; el.style.scrollTimelineAxis = 'x'; scope.style.timelineScope = name;
    pr.style.setProperty('--rd-tl', name); pr.setAttribute('data-rd-tl', '');
    function ratio() { var sw = el.scrollWidth; if (sw > 0) pr.style.setProperty('--rd-sp0', Math.min(1, el.clientWidth / sw).toFixed(4)); }
    ratio(); if (window.ResizeObserver) { var ro = new ResizeObserver(ratio); ro.observe(el); if (el.firstElementChild) ro.observe(el.firstElementChild); }
  }
  /* Obrázky karet: nativní loading=lazy v posuvníku dotahuje jen ~1250 px dopředu, takže po rychlém posunu o stránku zůstaly šedé rámečky.
     Jakmile je posuvník blízko okna (IO 1), začne se o jednu až dvě šířky okna dopředu i dozadu načítat vše (IO 2 s root = posuvník);
     obrázky dál zůstávají lazy, dokud k nim uživatel nedojede. */
  function preload(el) {
    if (!('IntersectionObserver' in window)) return;
    var imgs = [].slice.call(el.querySelectorAll('img[loading="lazy"]')); if (!imgs.length) return;
    var armed = false;
    function arm() {
      if (armed) return; armed = true;
      var io2 = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (!e.isIntersecting) return; var im = e.target; io2.unobserve(im);
          im.loading = 'eager'; if (im.decode) im.decode().catch(function () { });
        });
      }, { root: el, rootMargin: '0px 130% 0px 130%' });
      imgs.forEach(function (i) { if (!i.complete) io2.observe(i); });
    }
    var io1 = new IntersectionObserver(function (en) { if (en.some(function (e) { return e.isIntersecting; })) { io1.disconnect(); arm(); } }, { rootMargin: '700px 0px' });
    io1.observe(el);
  }
  function bind(el) {
    if (el.__rdSl) { upd(el); return; } el.__rdSl = 1;
    preload(el);
    /* Při streamovaném vykreslení HTML (mandatory snap + dosud nedoplněné karty) se řada občas ocitla na konci – ukazatel pokroku na 100 %.
       Dokud uživatel nesáhl na posuvník, vrátíme začátek a teprve potom zapneme snap (CSS: scroll-carousel:not([data-rd-ready]) = bez snapu). */
    var touched = false; ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (n) { el.addEventListener(n, function () { touched = true; }, { passive: true, once: true }); });
    if (!touched && el.scrollLeft > 0) el.scrollTo({ left: 0, behavior: 'auto' });
    el.setAttribute('data-rd-ready', '');
    /* odložené karty (<template data-rd-more>): vloží se při prvním pohybu / dotyku / scrollu, nebo po 10 s v klidu – bez nákladu při načtení */
    var tpl = el.querySelector('template[data-rd-more]');
    if (tpl) {
      /* vkládání po dvou kartách v klidu prohlížeče (ne naráz: inline skripty karet + restyle dělaly dlouhý úkol); start při přiblížení řady / dotyku, jinak po 10 s */
      var started = false;
      var inject = function () {
        if (started) return; started = true;
        var nodes = [].slice.call(tpl.content.children), idle = window.requestIdleCallback || function (c) { return setTimeout(function () { c({ timeRemaining: function () { return 8; } }); }, 60); };
        (function next() {
          if (!nodes.length) { tpl.remove(); el._items = undefined; preload(el); upd(el); return; }
          idle(function (d) {
            var n = 0; do { tpl.parentNode.insertBefore(nodes.shift(), tpl); n++; } while (nodes.length && n < 2 && d.timeRemaining() > 6);
            el._items = undefined; next();
          });
        })();
      };
      if ('IntersectionObserver' in window) { var io3 = new IntersectionObserver(function (en) { if (en.some(function (e) { return e.isIntersecting; })) { io3.disconnect(); inject(); } }, { rootMargin: '500px 0px' }); io3.observe(el); }
      ['pointerenter', 'touchstart', 'wheel', 'keydown'].forEach(function (n) { el.addEventListener(n, inject, { passive: true, once: true }); });
      var idleStart = function () { setTimeout(inject, 10000); };
      if (document.readyState === 'complete') idleStart(); else addEventListener('load', idleStart, { once: true });
    }
    setTimeout(function () { if (!touched && el.scrollLeft > 0 && el.scrollLeft >= el.scrollWidth - el.clientWidth - 2) { el.scrollTo({ left: 0, behavior: 'auto' }); upd(el); } }, 600);
    var raf = 0, t = 0;
    tl(el);
    function sched() {
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; upd(el); });
      if (!('onscrollend' in window)) { clearTimeout(t); t = setTimeout(function () { upd(el); }, 160); } /* po doběhu: přebije „edge-nearing“ šablony (práh 125 px) */
    }
    el.addEventListener('scroll', sched, { passive: true });
    if ('onscrollend' in window) el.addEventListener('scrollend', function () { upd(el); }, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(sched).observe(el);
    /* klávesnice: šipky vlevo/vpravo na zaostřeném posuvníku = stránka */
    el.addEventListener('keydown', function (e) {
      if (e.target !== el || e.altKey || e.ctrlKey || e.metaKey) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(el, 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(el, -1); }
    });
    if (el.tabIndex < 0 && !el.hasAttribute('tabindex')) el.tabIndex = 0;
    if (!el.hasAttribute('role')) { el.setAttribute('role', 'group'); el.setAttribute('aria-roledescription', 'carousel'); }
    if (!el.hasAttribute('aria-label')) {
      var sec = el.closest('.shopify-section'), h = sec && sec.querySelector('h2');
      if (h) el.setAttribute('aria-label', h.textContent.trim());
    }
    upd(el); setTimeout(function () { upd(el); }, 400);
  }
  function init() { document.querySelectorAll('[data-rd-slider]').forEach(bind); }
  document.addEventListener('rd:lazy-loaded', function () { init(); setTimeout(init, 300); });
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
